import script from "./BaseRadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadioButton.vue?vue&type=style&index=0&id=8b02b176&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b02b176"]])

export default __exports__